import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollReveal } from '@/components/ui/scroll-reveal';
import circleArrow from '@/assets/circle-arrow.svg';

const features = [
  "Daily practice sessions with jazz masters. Sit down, play, and learn in real musical context.",
  "Hands-on improvisation, not abstract theory. Everything is practical, repeatable, and meant for the practice room.",
  "A clear path forward when you feel stuck. No more guessing what to work on or how to practice.",
];

export function BuildSkillsSection() {
  const navigate = useNavigate();

  return (
    <section className="pt-12 md:pt-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div 
        className="max-w-6xl mx-auto px-6 sm:px-10 md:px-16 lg:px-20 pt-10 sm:pt-14 md:pt-16 lg:pt-20 pb-10 sm:pb-12"
        style={{
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 45.19%, rgba(0, 0, 0, 0.05) 100%)',
          borderRadius: '140px',
        }}
      >
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left - Headline */}
          <ScrollReveal>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display leading-tight">
              <span className="text-[#CB5EFF]">Build your skills</span>{' '}
              <span className="text-foreground">
                with hands-on lessons, improvisation drills, and tools that make learning jazz fun and accessible.
              </span>
            </h2>
          </ScrollReveal>

          {/* Right - Features */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <ScrollReveal key={index} delay={index * 0.1}>
                <div className="flex items-start gap-4">
                  <img src={circleArrow} alt="" className="w-10 h-10 flex-shrink-0" />
                  <p className="text-paragraph-1 text-foreground">{feature}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <ScrollReveal delay={0.3}>
          <div className="flex justify-center mt-12">
            <Button
              onClick={() => navigate('/plans')}
              variant="gradient"
              size="cta"
              className="text-button"
            >
              VIEW TENACITY PLANS
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
